import Field from "csi/def/Field";
import Widget from "csi/form/Widget";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import { featureTogglesStore } from "csi/state/rootStore";

const CareAndCompositionForm = declare(Widget, {
	/**
	 * @override
	 * Add Subtype field to the form if feature flag is True
	 */
	_resolveView() {
		const compositionFeatureFlagEnabled = featureTogglesStore.CAREANDCOMPOSITION_DATASHEET_USE_REACT_UI;
		if (compositionFeatureFlagEnabled) {
			this.insertField(lang.mixin(new Field(), {
				m_id: "Subtype",
			}), 0);
		}
		this.inherited(arguments);
	},
});
export = CareAndCompositionForm;